// ============================================================================
// Tab titles (Design Constitution Q41): 'Page · Program · WCF'.
// ----------------------------------------------------------------------------
// The page and program names come from the navigation's own labels
// (globalNav: SECTIONS_BY_PROGRAM, GLOBAL_DESTINATIONS, VIEW_TO_PROGRAM), so a
// tab reads the same words as the header. A program's dashboard is the
// program itself ('Cattle · WCF'); a top-level destination outside programs
// is its own page ('Tasks · WCF'). An unknown view reads just 'WCF'.
// ============================================================================
import {GLOBAL_DESTINATIONS, SECTIONS_BY_PROGRAM, VIEW_TO_PROGRAM} from './globalNav.js';

const PROGRAM_OF = VIEW_TO_PROGRAM as Readonly<Record<string, string | undefined>>;

// Pages outside the program navigation, in Title Case (Q35).
const OTHER_PAGES: Readonly<Record<string, string>> = Object.freeze({
  home: 'Home',
  animalHistory: 'Animal History',
  production: 'Production',
  tasks: 'Tasks',
  activity: 'Activity',
  clientErrors: 'Client Errors',
  webformhub: 'Daily Reports',
  tasksWebform: 'Submit a Task',
  webform: 'Daily Reports',
  addfeed: 'Add Feed',
  weighins: 'Weigh-Ins',
  fuelingHub: 'Fueling',
  fuelSupply: 'Fuel Supply',
  weighinsessions: 'Weigh-In Session',
  mySubmissions: 'My Submissions',
  weather: 'Weather',
  processingCutSheet: 'Cut Sheet',
  equipmentAdminRecord: 'Equipment',
  newsletter: 'Newsletter',
  newsletterAdmin: 'Newsletter',
});

function programLabel(program: string): string | null {
  const dest = GLOBAL_DESTINATIONS.find((d) => d.program === program);
  return dest ? dest.label : null;
}

export function titleParts(view: string | null | undefined): {page: string | null; program: string | null} {
  if (!view) return {page: null, program: null};
  const program = PROGRAM_OF[view];
  if (program) {
    const programName = programLabel(program);
    const section = (SECTIONS_BY_PROGRAM[program] || []).find((s) => s.view === view);
    if (!section || section.label === 'Dashboard') return {page: programName, program: null};
    return {page: section.label, program: programName};
  }
  if (OTHER_PAGES[view]) return {page: OTHER_PAGES[view], program: null};
  const dest = GLOBAL_DESTINATIONS.find((d) => d.view === view);
  return {page: dest ? dest.label : null, program: null};
}

export function titleForView(view: string | null | undefined): string {
  const {page, program} = titleParts(view);
  return [page, program, 'WCF'].filter((p): p is string => typeof p === 'string' && p.trim() !== '').join(' · ');
}
